module.exports = __webpack_public_path__ + "img/wild_comming.59aaa72a.png";